import React from 'react';

export default function ImagePlaceholder({ name, width = '100%', height = '320px', style = {} }) {
  return (
    <div
      style={{
        width,
        height,
        background: '#F9FEFF',
        border: '2px dashed rgba(63,196,227,0.4)',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        ...style,
      }}
    >
      <div style={{ color: 'rgba(63,196,227,0.6)', fontSize: '28px' }}>🖼</div>
      <div style={{ color: '#9CA3AF', fontFamily: 'popinsMedium', fontSize: '13px', textAlign: 'center', padding: '0 16px' }}>
        {name}
      </div>
    </div>
  );
}
